<div *ngIf="form" [formGroup]="form">
	<mat-form-field [style.width]="width">
		<mat-label *ngIf="label">{{label}}</mat-label>
		<!--The key here is only setting the input type to 'password' when there is a value present.
			If there is a value already present when the page loads (such as by form control binding), then the browser will not overwrite it.
			If there is no value when the page loads, then the input will be of type 'text', and the browser will not attempt to auto-fill anything.
			The browser may /offer/ to auto-fill after the page has loaded and the user has played with the input value, but at that point,
			this component has already served its purpose by preventing the initial uncontrollable auto-fill, so we don't particularly care.-->
		<input matInput [type]="form.get('value').value ? 'password' : 'text'" [formControl]="form.get('value')" />
	</mat-form-field>
</div>
